import React, { ReactNode, useState } from "react";

interface Tab {
  label: string;
  component: ReactNode;
}

interface MobileTabSwitcherProps {
  tabs: Tab[];
  onTabChange?: (index: number) => void;
}

const MobileTabSwitcher: React.FC<MobileTabSwitcherProps> = ({
  tabs,
  onTabChange,
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleTabSelect = (index: number) => {
    if (index !== activeTabIndex) {
      setActiveTabIndex(index);
      onTabChange?.(index);
    }
  };

  return (
    <div className="flex flex-col w-full" style={{ minHeight: 0, flex: 1 }}>
      {/* Tab Headers */}
      <div className="w-full shrink-0">
        <div className="flex border border-border-subtle rounded-2xl p-[2px]">
          {tabs.map((tab, idx) => (
            <div
              key={tab.label}
              className={[
                "flex-1 flex items-center justify-center relative cursor-pointer rounded-2xl p-1",
                activeTabIndex === idx && "bg-bg-button-secondary",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => handleTabSelect(idx)}
            >
              {idx > 0 && (
                <div className="absolute left-0 top-1/2 border-l border-border-subtle -translate-y-1/2 h-5" />
              )}
              <span
                className={[
                  "w-full text-center font-medium rounded-2xl transition duration-300 flex items-center justify-center text-[12px] px-3 py-1",
                  activeTabIndex === idx
                    ? "text-white"
                    : "text-text-tab-default",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                {tab.label.toUpperCase()}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="w-full overflow-auto mt-2" style={{ flex: 1, minHeight: 0 }}>
        {tabs[activeTabIndex]?.component}
      </div>
    </div>
  );
};

export default MobileTabSwitcher;
